import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import OurPrinciplesPage from "@/pages/OurPrinciplesPage";
import StatisticsPage from "@/pages/StatisticsPage";
import CriteriaDatabasePage from "@/pages/CriteriaDatabasePage";
import MethodologyPage from "@/pages/MethodologyPage";
import AdvisoryBoardPage from "@/pages/AdvisoryBoardPage";
import ReportPage from "@/pages/ReportPage";
import ResearchStandardsPage from "@/pages/ResearchStandardsPage";
import HowWeUseDataPage from "@/pages/HowWeUseDataPage";
import AboutProjectPage from "@/pages/AboutProjectPage";
import StatusPage from "@/pages/StatusPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCriteria from "@/pages/AdminCriteria";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/principles" element={<OurPrinciplesPage />} />
            <Route path="/data" element={<StatisticsPage />} />
            <Route path="/database" element={<CriteriaDatabasePage />} />
            <Route path="/methodology" element={<MethodologyPage />} />
            <Route path="/advisory" element={<AdvisoryBoardPage />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/research-standards" element={<ResearchStandardsPage />} />
            <Route path="/data-use" element={<HowWeUseDataPage />} />
            <Route path="/about" element={<AboutProjectPage />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/criteria"
              element={
                <ProtectedRoute>
                  <AdminCriteria />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
